var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['loader__container', _vm.$props.classes, {
      hide: _vm.hide
    }],
    style: _vm.customStyles
  }, [_c('svg', {
    staticClass: "loader__circle",
    attrs: {
      "viewBox": "0 0 400 400",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    staticClass: "loader__track",
    attrs: {
      "cx": "50%",
      "cy": "50%",
      "r": "190"
    }
  }), _c('circle', {
    ref: "progress",
    staticClass: "loader__track loader__progress",
    attrs: {
      "cx": "50%",
      "cy": "50%",
      "r": "190"
    }
  })]), _c('svg', {
    staticClass: "loader__checkerboard",
    attrs: {
      "viewBox": "0 0 400 400",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    staticClass: "loader__box",
    attrs: {
      "d": "M 5 5 L 395 5 L 395 395 L 5 395 Z"
    }
  }), _c('path', {
    staticClass: "loader__square",
    attrs: {
      "d": "M 200 0 L 400 0 L 400 200 L 200 200 Z"
    }
  }), _c('path', {
    staticClass: "loader__square loader__square--bottom",
    attrs: {
      "d": "M 0 400 L 0 200 L 200 200 L 200 400 Z"
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }